import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Question, QuestionGroup, QuestionOption } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-test-step-group-list',
    templateUrl: './test-step-group-list.component.html',
    styleUrls: ['./test-step-group-list.component.scss'],
})
export class TestStepGroupListComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy {
    public selected: { [key: number]: QuestionOption } = {};
    public groups: QuestionGroup[];
    public stepNumber: number;

    @Input()
    question: Question;

    @Input()
    from = 0;

    @Input()
    step: string;

    @Input()
    totalSteps: number;

    @Input()
    disabledOptions: number[] = [];

    @Output()
    public next: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public back: EventEmitter<boolean> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    get isLastQuestion(): boolean {
        return this.stepNumber === this.totalSteps;
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('step' in changes && changes.step.currentValue) {
            this.stepNumber = Math.round(Number(this.step));
        }

        if ('question' in changes && changes.question.currentValue) {
            this.groups = this.question.groups.slice(this.from, this.from + 5);
            this.setDefaultSelected();
        }

        if ('from' in changes && changes.from.currentValue) {
            if (this.question && this.question.groups && this.question.groups.length > this.from) {
                this.groups = this.question.groups.slice(this.from, this.from + 5);
                this.setDefaultSelected();
            }
        }
    }

    private setDefaultSelected() {
        this.selected = {};
        this.groups.map((group, idx) => {
            group.options.map((option) => {
                if (option.selected) {
                    this.selected[idx] = option;
                }
            });
        });
    }

    isDisabled(idx: number): boolean {
        return this.disabledOptions.indexOf(idx) !== -1;
    }

    onBack() {
        this.back.emit(true);
    }

    onClick() {
        this.next.emit(true);
    }

    onSelectedChange(idx: number) {
        this.question.groups[this.from + idx].options.map((option) => {
            option.selected = String(option.id) === String(this.selected[idx].id);
        });
    }
}
